import { isNorthstarBrand } from '../brandConfig';
export const breakpointSizes = {
    xsmall: 320,
    small: 420,
    smallPlus: 430,
    medium: 768,
    large: 1024,
    xlarge: isNorthstarBrand ? 1440 : 1280,
    xxl: 2560,
};
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["XXL"] = "xxl";
    Breakpoints["XLARGE"] = "xlarge";
    Breakpoints["LARGE"] = "large";
    Breakpoints["MEDIUM"] = "medium";
    Breakpoints["SMALL"] = "small";
    Breakpoints["SMALLPLUS"] = "smallPlus";
    Breakpoints["XSMALL"] = "xsmall";
})(Breakpoints || (Breakpoints = {}));
//# sourceMappingURL=breakpoints.js.map